// src/components/FeaturedProducts/FeaturedProducts.jsx

import React from 'react';
import './FeaturedProducts.css';
import { Link } from 'react-router-dom';
// Marka verisini alıyoruz (başlık için) - productData.js'den
import { brands } from '../data/productData'; // Bu dosyanın var olduğundan emin ol

// Helper function: Yükleniyor iskeletini render eder
const renderLoadingSkeleton = () => {
  return (
    <section className="featured-container">
      <h2 className="featured-title">Ürünler Yükleniyor...</h2>
      <div className="featured-grid">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="product-card is-loading">
            <div className="product-card-image-wrapper">
              <div className="placeholder-img"></div>
            </div>
            <div className="product-card-info">
              <p className="product-card-category placeholder-text"></p>
              <h3 className="product-card-name placeholder-text"></h3>
              <p className="product-card-price placeholder-text"></p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

function FeaturedProducts({
  products,
  isSearching,
  loading,
  selectedCategory,
  selectedBrand,
  isFiltering
}) {

  // Yüklenme (Loading) durumu
  if (loading) {
    return renderLoadingSkeleton(); // Helper fonksiyonu çağır
  }

  // Başlığı dinamik olarak belirle (Bileşen içinde tanımlı)
  const getTitle = () => {
    if (isSearching) return 'Arama Sonuçları';
    if (selectedCategory) return `${selectedCategory} Ürünleri`;
    if (selectedBrand) {
      const brandName = brands.find(b => b.id === selectedBrand)?.name || selectedBrand;
      return `${brandName} Markalı Ürünler`;
    }
    if (isFiltering) return 'Filtrelenmiş Ürünler';
    return 'Öne Çıkan Ürünler';
  };

  // Yüklenme bittiyse gerçek içeriği göster
  return (
    <section className="featured-container">

      <h2 className="featured-title">{getTitle()}</h2>

      {/* Güvenlik kontrolü */}
      {products && Array.isArray(products) && products.length > 0 ? (
        // Sonuç varsa, grid'i göster
        <div className="featured-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <Link to={`/urunler/${product.id}`} className="product-card-link">
                <div className="product-card-image-wrapper">
                  <img
                    src={product.imageUrl || 'https://via.placeholder.com/300?text=Resim+Yok'} // Fallback eklendi
                    alt={product.name}
                    className="product-card-img"
                    onError={(e) => { e.target.onerror = null; e.target.src="https://via.placeholder.com/300?text=Resim+Yok" }}
                  />
                </div>
                <div className="product-card-info">
                  <p className="product-card-category">
                    {product.mainCategoryName || 'Kategori Yok'}
                  </p>
                  <h3 className="product-card-name">{product.name || 'İsimsiz Ürün'}</h3> {/* Fallback */}
                  <p className="product-card-price">
                    {/* Fiyatın number olduğundan emin olalım */}
                    {typeof product.price === 'number' ? product.price.toFixed(2) : '0.00'} TL
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        // Sonuç yoksa mesaj göster
        <div className="featured-no-results">
          {isSearching ? "Aradığınız kritere uygun ürün bulunamadı."
            : isFiltering ? "Bu filtrelere uygun ürün bulunamadı."
            : "Gösterilecek ürün bulunamadı."}
        </div>
      )}

      {/* "Tümünü Gör" butonu */}
      {/* Herhangi bir filtre aktif DEĞİLSE göster */}
      {/* --- DÜZELTME BURADA: İçerik eklendi --- */}
      {!isSearching && !isFiltering && (
        <div className="featured-view-all">
          <Link to="/urunler" className="view-all-button">
            Tümünü Gör
          </Link>
        </div>
      )}

    </section>
  );
}

export default FeaturedProducts;